import { Truck, Store, UtensilsCrossed, CalendarDays, TriangleAlert as AlertTriangle, Building2 } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const applications = [{
  icon: Truck,
  title: "Food distribution",
  description: "Potential temporary refrigerated storage for shipments during staging and logistics handoffs. Confirm requirements with our team."
}, {
  icon: Store,
  title: "Grocery operations",
  description: "Potential temporary refrigerated storage for seasonal inventory, store remodels, or cooler overflow. Confirm requirements with our team."
}, {
  icon: UtensilsCrossed,
  title: "Catering",
  description: "Potential temporary refrigerated storage for catering ingredients and prepared food. Confirm temperature and loading requirements with our team."
}, {
  icon: CalendarDays,
  title: "Events",
  description: "Potential temporary refrigerated storage for food and beverages at events. Confirm site access, temperature, and loading requirements with our team."
}, {
  icon: AlertTriangle,
  title: "Emergency cold storage",
  description: "Potential temporary refrigerated storage during equipment downtime or facility disruptions, subject to location, timing, and availability."
}, {
  icon: Building2,
  title: "Commercial projects",
  description: "Potential temporary refrigerated storage for planned commercial projects, facility maintenance, or operational needs. Confirm suitability with our team."
}];
export default function PotentialApplications() {
  return <section id="potentialapplications" data-nav="light" className="bg-background text-foreground py-16 sm:py-20 lg:py-24 border-b border-border/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-default font-bold tracking-tight text-foreground">
            Potential Applications
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {applications.map((item, i) => {
          const Icon = item.icon;
          return <div key={item.title} data-index={i}>
                <Card className="h-full border border-border bg-card shadow-xs transition-shadow duration-200 hover:shadow-md">
                  <CardHeader className="space-y-4 pb-2">
                    <div className="size-12 rounded-lg bg-accent/60 text-accent-foreground flex items-center justify-center shrink-0">
                      <Icon className="size-6 text-primary" aria-hidden="true" />
                    </div>
                    <CardTitle className="text-xl font-semibold text-card-foreground">
                      {item.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm sm:text-base leading-relaxed text-foreground/80">
                      {item.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}